import { computed } from 'vue';
import yup from '@component_path/inquiry_form_common_module/customValidation';

export const useSexField = (required, messages = {}) => {
  const validator = yup
    .string()
    .requirement(required, messages['requirement'] || '性別は必須項目です');
  const fieldName = computed(() => 'sex');

  return { fieldName, validator };
};
